<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      legends: [
        { name: "Off Ramp", color: "orange" },
        { name: "Entrance", color: "teal" },
        { name: "Exit", color: "red" },
      ],
    };
  },
  methods: {
    formattedAverage(value) {
      const resultValue = Number(value);
      if (!isNaN(resultValue)) {
        const roundedValue = resultValue.toFixed(0);
        return new Intl.NumberFormat("id-ID").format(roundedValue);
      }
      return value;
    },
    formattedNumber(value) {
      const resultValue = Number(value);
      if (!isNaN(resultValue)) {
        const roundedValue = resultValue.toFixed(0);
        return new Intl.NumberFormat("id-ID").format(roundedValue);
      }
      return value;
    },
    getColorByType(type) {
      switch (type) {
        case "off_ramp":
          return "orange";
        case "entrance":
          return "teal";
        case "exit":
          return "red";
        default:
          return "grey";
      }
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollLeft -= 200;
        container.behavior = "smooth";
      }
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollLeft += 200;
        container.behavior = "smooth";
      }
    },
  },
};
</script>

<template>
  <div class="py-4 px-10">
    <v-card class="pt-5 pb-3 rounded-xl" outlined>
      <v-row no-gutters class="text-center">
        <v-col class="text-uppercase">
          <h3 style="font-size: 14px; font-weight: 600">Total Pendapatan</h3>
          <h1 class="text-capitalize" style="font-size: 42px; font-weight: 500">
            Rp. {{ formattedNumber(data.total) }}
          </h1>

          <h4 style="font-size: 10px; font-weight: 600">
            PENDAPATAN REKONSILIASI
          </h4>
          <h1 class="text-capitalize" style="font-size: 14px; font-weight: 500">
            Rp. {{ formattedNumber(data.total_reconcile) }}
          </h1>
        </v-col>
        <v-col class="text-uppercase">
          <h3 style="font-size: 14px; font-weight: 600">Rerata</h3>
          <h1 class="text-capitalize" style="font-size: 42px; font-weight: 500">
            Rp. {{ formattedAverage(data.average) }}
          </h1>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <v-row no-gutters justify="center" align="center">
        <div
          v-for="(legend, index) in legends"
          :key="index"
          class="mx-4"
          outlined
        >
          <v-avatar left size="8" class="mr-2" :color="legend.color"></v-avatar>
          <span style="font-size: 12px">{{ legend.name }}</span>
        </div>
      </v-row>

      <v-row
        no-gutters
        class="py-1 position-relative"
        justify="center"
        align="center"
        style="position: relative"
      >
        <v-btn
          class="px-3 rounded-lg"
          style="
            background-color: white;
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
            border: 1px solid #004643;
            height: 45px;
            width: 45px;
            padding-left: 10px;
            padding-right: 10px;
          "
          icon
          @click="scrollLeft"
        >
          <v-icon style="color: #004643">mdi-chevron-left</v-icon>
        </v-btn>

        <div
          ref="scrollContainer"
          class="d-flex align-center"
          style="overflow-x: scroll; max-width: 90%; scroll-behavior: smooth"
        >
          <v-col
            cols="auto"
            v-for="(data, index) in data.gate_details"
            :key="index"
          >
            <div
              outlined
              class="d-flex align-center py-3 px-5 rounded-lg"
              :style="{
                borderColor: getColorByType(data.type),
                borderWidth: '1px',
                borderStyle: 'solid',
              }"
            >
              <v-avatar
                class="mr-3"
                size="10"
                :color="getColorByType(data.type)"
              ></v-avatar>
              <div>
                <h5 style="font-size: 16px; font-weight: 400">
                  {{ data.gate_name }}
                </h5>
                <p
                  class="pt-1 pr-10 ma-0"
                  style="font-size: 14px; font-weight: 400"
                >
                  Rp. {{ formattedNumber(data.total) }}
                </p>
              </div>
            </div>
          </v-col>
        </div>

        <v-btn
          class="px-3 rounded-lg"
          style="
            background-color: white;
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            border: 1px solid #004643;
            height: 45px;
            width: 45px;
            padding-left: 10px;
            padding-right: 10px;
          "
          icon
          @click="scrollRight"
        >
          <v-icon style="color: #004643">mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>
